import { Routes } from '@angular/router';
import { authGuard, roleGuard, guestGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes)
  },
  {
    path: 'orders',
    canActivate: [authGuard],
    loadChildren: () => import('./features/orders/orders.routes').then(m => m.orderRoutes)
  },
  {
    path: 'users',
    canActivate: [authGuard, roleGuard(['admin', 'internal'])],
    loadChildren: () => import('./features/users/users.routes').then(m => m.userRoutes)
  },
  {
    path: 'admin',
    canActivate: [authGuard, roleGuard(['admin'])],
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes)
  },
  // {
  //   path: 'profile',
  //   canActivate: [authGuard],
  //   loadChildren: () => import('./features/profile/profile.routes').then(m => m.profileRoutes)
  // },
  {
    path: '**',
    redirectTo: '/auth/login'
  }
];
